import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { DefaultEditorFieldsList } from "../DefaultEditorFieldsList";
import { useCategorizedBlockProps } from "../useCategorizedBlockProps";
import { DefaultEditorV2FieldsList } from "./DefaultEditorV2FieldsList";
import { DEFAULT_EDITOR_V2_STYLE_CATEGORIES } from "./constants";
import { groupFieldsByStyleCategory } from "./utils";

export interface DefaultEditorProps {
  meta: ComponentMeta;
}

export const DefaultEditorV2 = ({ meta }: DefaultEditorProps) => {
  const { tabOnlyGroups, nestedGroups, unCategorizedProps, tabCategories } =
    useCategorizedBlockProps(meta);

  const [firstCategory, ...restCategories] = tabCategories;
  const contentFields = firstCategory ? tabOnlyGroups[firstCategory] || [] : [];

  const remappedGroups = groupFieldsByStyleCategory(
    nestedGroups,
    restCategories,
  );

  const sortedStyleCategories = DEFAULT_EDITOR_V2_STYLE_CATEGORIES.map(
    ({ key, nameI18n }) => ({
      key,
      nameI18n,
      fields: remappedGroups[key] || [],
    }),
  ).filter(({ fields }) => fields.length > 0);

  return (
    <div className="flex flex-col divide-y border-b">
      {contentFields.length > 0 && (
        <DefaultEditorFieldsList fields={contentFields} />
      )}
      {sortedStyleCategories.map(({ key, nameI18n, fields }) => (
        <DefaultEditorV2FieldsList
          key={key}
          title={key}
          titleI18n={nameI18n}
          fields={fields}
        />
      ))}
      {unCategorizedProps.length > 0 && (
        <DefaultEditorFieldsList fields={unCategorizedProps} />
      )}
    </div>
  );
};
